import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import checkboxIcon from 'icons/checkboxIcon.js'
import Anchor from 'components/Anchor'
import styles from './inputField-style.css'
import property from 'lodash/property'

const propTypes = {
  children: PropTypes.node,
}

// Add any default values for props
const defaultProps = {}

function InputField({
  type,
  id,
  label,
  value,
  onChange,
  onBlur,
  className,
  error,
  errors,
  touched,
  link,
  title,
  disableAutofill,
  children,
  ...props
}) {
  const errorMsg = errors && property(id)(errors)
  const isTouched = touched && property(id)(touched)
  /* eslint-disable jsx-a11y/label-has-for */
  return (
    <div
      className={cx(
        styles.inputField,
        className,
        isTouched && errorMsg && styles.inputFieldError,
        styles[type],
      )}
    >
      {title && <h4 style={{ margin: '0' }}>{title}</h4>}
      <label htmlFor={id}>
        {type !== 'checkbox' && label}
        {type !== 'checkbox' && link && (
          <span>
            {' '}
            - <Anchor {...link} />
          </span>
        )}
        {type === 'textarea' && (
          <textarea
            {...props}
            id={id}
            type={type}
            value={value || ''}
            onBlur={onBlur}
            onChange={onChange}
            rows="8"
            data-invalid={error || errorMsg ? 'true' : undefined}
          />
        )}
        {(type === 'text' ||
          type === 'email' ||
          type === 'checkbox' ||
          type === 'tel' ||
          type === 'number') && (
          <input
            {...props}
            spellCheck
            id={id}
            type={type}
            value={value || ''}
            onBlur={(onBlur && onBlur) || null}
            onChange={onChange}
            autoComplete={disableAutofill ? 'off' : 'on'}
            data-invalid={error || errorMsg ? 'true' : undefined}
          />
        )}
        {type === 'checkbox' && (
          <span className="checkbox">{checkboxIcon()}</span>
        )}
        {type === 'checkbox' && label}
        {type === 'checkbox' && link && (
          <span>
            {' '}
            - <Anchor {...link} />
          </span>
        )}
      </label>

      {/* render link with modal for each link (if a link is provided) */}
      {children}

      {(isTouched && errorMsg) ||
        (error && (
          <div className={styles.inputFieldError}>{errorMsg || error}</div>
        ))}
    </div>
  )
}

InputField.displayName = 'InputField'
InputField.propTypes = propTypes
InputField.defaultProps = defaultProps

export default InputField



// WEBPACK FOOTER //
// ./src/components/InputField/InputField.js